import UrlService from "../../core/services/url.service";
import * as $numberHelper from "../../core/helpers/number.helper";
import { UiStringModel } from "../../core/models/ui-string.model";
import moment from 'moment';
import { CartModel, TicketModel } from "../../core/models/cart.model";


// work around scoping when calling "$parents[index].[method]" from "foreach" 
let cartInstance: ShoppingCartViewModel;

class ShoppingCartViewModel {
    private urlService: UrlService;
    private uiStrings: UiStringModel;

    constructor(private params: any) {
        cartInstance = this;
        this.shoppingCartVm = params.value;

        const shoppingCartSubscriber = this.shoppingCartVm.subscribe((data) => {
            if (!this.cartWasLoadedInitially() && data) {
                shoppingCartSubscriber.dispose();
                this.cartWasLoadedInitially(true);
                this.ReloadShoppingCart(data);
            }
        });

        this.urlService = params.urlService as UrlService;
        this.uiStrings = params.uiStrings as UiStringModel;

        if (params.isDataCollectionComplete) {
            this.isDataCollectionComplete = params.isDataCollectionComplete;
        } else {
            this.isDataCollectionComplete = ko.observable(false);
        }

        this.currency = ko.observable(this.uiStrings.currency);
        this.allowModification = ko.observable(params.allowChanges);
        this.accountId = params.accountId;
        this.isFrame = ko.observable(params.isFrame === true);
        this.surchargePercentage = params.surcharge;
        this.links = params.links;

        if (params.surchargeLabel && params.surchargeLabel.length > 0) {
            this.surchargeLabel(params.surchargeLabel);
        }

        // EVENTS
        const $window = $(window);
        this.windowWidth($window.width());
        $window.resize(() => {
            this.windowWidth($window.width());
        });
        
        if (params.cartTicketCount) {
            params.cartTicketCount(this.cartTicketCount);
        }
    }

    public shoppingCartVm: KnockoutObservable<CartModel>;
    public isDataCollectionComplete: KnockoutObservable<boolean>;
    public currency: KnockoutObservable<string>;
    public allowModification: KnockoutObservable<boolean>;
    public accountId: KnockoutObservable<number>;
    public isFrame: KnockoutObservable<boolean>;
    public surchargePercentage: KnockoutObservable<number>;
    public links: KnockoutObservable<any>;

    public cartWasLoadedInitially = ko.observable(false);

    public hasPromoCodeError = ko.observable(false);
    public promoErrorMessage = ko.observable('');
    public promoErrorMessages = ko.observableArray([]);
    public promoCode = ko.observable('');
    public shouldShowPromoMessage = ko.observable(false);
    public showAppliedPromoButtonLabel = ko.observable(false);
    public lastEventId = ko.observable(0);
    public redirectToGcSummary = ko.observable(false);
    public isFreeBooking = ko.observable(false);

    public hidePromoCodeSection = ko.observable(false);
    public promoCodesApplied = ko.observableArray([]);
    public promotionCodes = ko.observableArray([]);
    public promoMessage = ko.observable('');

    public bookingTickets = ko.observableArray([]);
    public bookingGCs = ko.observableArray([]);
    public totalOGAmount = ko.observable(0);
    public totalTicketAmount = ko.observable('');
    public cartTicketCount = ko.observable(0);
    public totalTryBookingFee = ko.observable('');
    public totalTicketProcessingFee = ko.observable('');
    public totalGcAmount = ko.observable('');
    public cartGcCount = ko.observable(0);
    public cartDetailLabel = ko.observable('Show detail');
    public discounts = ko.observable('');
    public miscellaneous = ko.observable('');
    public cartIsLoading = ko.observable(false);

    public surchargeLabel = ko.observable('Surcharge');

    // Account
    public accountHasOtherEvents = ko.observable(false);
    public isGcEnabled = ko.observable(false);

    //Box Office
    public boxOfficeFee = ko.observable('');
    public boxOfficeHasError = ko.observable(false);
    public boxOfficeFeeEventId = ko.observable(0);
    public boxOfficeFeeOverridable = ko.observable(false);
    public hasBoxOfficeFee = ko.observable(false);

    public windowWidth = ko.observable(0);
    public lgDevice = ko.pureComputed(() => {
        return this.windowWidth() >= 991;
    });

    public shouldShowGcOrPromoApplication = ko.pureComputed(() =>
        !this.hidePromoCodeSection()
        && (this.allowModification() || this.promoCodesApplied().length > 0)
        && !this.isFrame());

    public shouldShowSubtotal = ko.pureComputed(() => !this.isFreeBooking() && !this.isFrame());

    public shouldShowBuyMoreLinks = ko.pureComputed(() => this.allowModification() && !this.isFrame());

    public gcApplyEnabled = ko.pureComputed(() => this.hasPromoCodeError() === false && !this.showAppliedPromoButtonLabel());

    public showBuyMoreTickets = ko.pureComputed(() => this.bookingTickets().length > 0);

    public showFindOtherEvents = ko.pureComputed(() => this.accountHasOtherEvents());

    public showBuyGc = ko.pureComputed(() => this.isGcEnabled());

    public totalAmount = ko.pureComputed(() => {
        var amount = ((this.totalOGAmount() * this.surchargePercentage()) + (this.totalOGAmount() * 100)) / 100;
        return $numberHelper.ToCurrency(amount);
    });

    public surchargeAmount = ko.pureComputed(() => {
        const amount = ((parseFloat(this.totalAmount()) * 100) - (parseFloat($numberHelper.ToCurrency(this.totalOGAmount())) * 100)) / 100;

        return $numberHelper.ToCurrency(amount);
    });

    public HasValidPromoAndGc(ticketTypeIds: number[]) {
        if (this.params.methods && this.params.methods().checkHasValidPromoCodes) {

            var requestModel = {
                EventAccountId: this.accountId(),
                TicketTypeIds: ticketTypeIds
            };

            this.params.methods().checkHasValidPromoCodes(requestModel)
                .then((hasValidGcAndPromo: boolean) => {
                    this.hidePromoCodeSection(!hasValidGcAndPromo);
                });
        }

    }

    public ReloadShoppingCart(data: CartModel) {
        this.shoppingCartVm(data);
            let cartTicketCount = 0;
            if ((data.tickets === null || data.tickets.length === 0)
                && (data.giftCertificates === null || data.giftCertificates.length === 0)) {
                if (this.params.methods && this.params.methods().onNoCartItems) {
                    this.params.methods().onNoCartItems(this.lastEventId(), this.redirectToGcSummary());
                }
            }
            const bookingEvents: any[] = [];
            const ticketTypeIds: any[] = [];
            let isDataCollectionComplete = true;
            data.tickets.forEach((ticket: TicketModel) => {

                // Get the index for a booking event with the same Id as this ticket?
                const i = bookingEvents.findIndex((val: any) => {
                    return val.eventId === ticket.event.id;
                });



                const ticketData = this.MapTicketData(ticket, data.seats);

                if (isDataCollectionComplete && !ticketData.isCompleted) {
                    isDataCollectionComplete = false;
                }

                if (this.isFreeBooking() && data.giftCertificates !== null && data.giftCertificates.length > 0 && !ticketData.isFree) {
                    this.isFreeBooking(false);
                }

                if (i >= 0) {
                    bookingEvents[i].tickets.push(ticketData);
                } else {
                    bookingEvents.push({
                        eventName: ticket.event.name,
                        eventId: ticket.event.id,
                        tickets: [ticketData],
                        sessionPageUrl: this.urlService.GetSessionPageUrl(ticket.event.id),
                        donation: null
                    });
                }

                if ($.inArray(ticket.ticketType.id, ticketTypeIds) <= -1) {
                    ticketTypeIds.push(ticket.ticketType.id);
                }
                cartTicketCount += ticket.quantity * ticket.ticketType.quantity;
            });

            if (isDataCollectionComplete) {
                this.isDataCollectionComplete(isDataCollectionComplete);
            }

            $.each(data.donations, (index: number, value: any) => {
                var i = bookingEvents.findIndex((val) => {
                    return val.eventId === value.eventId;
                });

                if (bookingEvents[i]) {
                    bookingEvents[i].donation = this.MapDonationData(value);
                }
            });

            this.promoCodesApplied([]);
            const promoCodesApplied: any[] = [];
            $.each(data.promotionCodeDetails, (index: number, value: any) => {
                if (value.isPromoGC) {
                    var promoCode = this.MapPromoCodesApplied(value);
                    this.promoCodesApplied.push(promoCode);
                }

                promoCodesApplied.push(value.code);
            });

            //check if we can replace this
            this.promotionCodes([]);
            if (data.promotionCodeDetails) {
                this.promotionCodes(data.promotionCodeDetails);
            }

            if (promoCodesApplied.length > 0) {
                this.promoMessage(promoCodesApplied.join(', ') + ' applied');
            }

            this.bookingTickets(bookingEvents);

            this.bookingGCs([]);
            if (data.giftCertificates !== null) {
                this.cartGcCount(data.giftCertificates.length);
                this.bookingGCs(this.MapGiftCertificateBookingList(data.giftCertificates));
            }

            this.cartTicketCount(cartTicketCount);

            this.totalOGAmount(data.totalAmount);
            if (this.params.totalAmount) {
                this.params.totalAmount(data.totalAmount);
            }
            let totalTicketAmount = 0;
            $.each(data.tickets, (index: number, value: any) => {
                totalTicketAmount += value.ticketType.value * value.quantity
            });
            this.totalTicketAmount($numberHelper.ToCurrency(totalTicketAmount));

            let totalBookingFee = 0;
            $.each(data.tickets, (index: number, value: any) => {
                totalBookingFee += value.ticketFee;
            });
            $.each(data.giftCertificates, (index: number, value: any) => {
                totalBookingFee += value.bookingFee;
            });

            this.totalTryBookingFee($numberHelper.ToCurrency(totalBookingFee));

            let procFee = data.totalBoxOfficeProcessingFee + data.totalDonationProcessingFee + data.totalTicketProcessingFee + data.totalGCProcessingFee;
            if (procFee > 0 && this.params.showProcessingFeeObservable) {
                this.params.showProcessingFeeObservable(true);
            }

            this.totalTicketProcessingFee($numberHelper.ToCurrency(procFee));
            this.totalGcAmount($numberHelper.ToCurrency(data.totalGCAmount));

            let discounts = data.totalAppliedGiftCertificate + data.totalDiscountAmount;
            this.discounts($numberHelper.ToCurrency(discounts));

            let miscellaneous = data.totalDonations;
            this.miscellaneous($numberHelper.ToCurrency(miscellaneous));

            let totalBoxofficeAmount = isNaN(data.totalBoxOfficeFees) ? 0.00 : data.totalBoxOfficeFees;
            this.boxOfficeFee(this.currency() + $numberHelper.ToCurrency(totalBoxofficeAmount).toString());
            this.hasBoxOfficeFee(data.boxOfficeFees !== null && data.boxOfficeFees.length > 0);

            if (this.hasBoxOfficeFee() && this.allowModification()) {
                this.boxOfficeFeeEventId(data.boxOfficeFees[0].eventId);
                this.boxOfficeFeeOverridable(data.boxOfficeFees[0].isOverrideEnabled);
            }

            if (this.params.methods && this.params.methods().getAccountHasOtherEvents) {
                let eid = 0;
                if (bookingEvents && bookingEvents !== null && bookingEvents[0] !== null && bookingEvents.length > 0) {
                    eid = bookingEvents[0].eventId;
                }
                this.params.methods().getAccountHasOtherEvents(this.accountId(), eid)
                    .then((sData: any) => {
                        this.accountHasOtherEvents(sData);
                    });
            }

            if (this.params.methods && this.params.methods().getAccountHasGcs) {
                this.params.methods().getAccountHasGcs(this.accountId())
                    .then((sData: any) => {
                        this.isGcEnabled(sData);
                    });
            }
            this.HasValidPromoAndGc(ticketTypeIds);
            this.cartIsLoading(false);

            if (this.params.methods && this.params.methods().onShoppingCartLoaded) {
                this.params.methods().onShoppingCartLoaded();
            }

            if (this.params.methods && this.params.methods().updateCartDetails) {
                this.params.methods().updateCartDetails({ cartCount: this.cartTicketCount() + this.cartGcCount(), cartTotal: this.totalAmount(), cartTickets: this.bookingTickets() });
        }
       
        return;
    }

    public resetPromoError() {
        this.hasPromoCodeError(false);
        this.promoErrorMessage('');
        this.promoErrorMessages([]);
    };

    public applyPromoCode() {
        if (this.promoCode().trim().length === 0 || !this.allowModification()) return;
        this.cartIsLoading(true);

        const promoCodes: any[] = [];

        var promoCodeInputList = this.promoCode().split(" ");

        $.each(promoCodeInputList, (i: number, v: any) => {
            if (v.length > 0) {
                promoCodes.push(v);
            }
        });
        if (promoCodes.length <= 0) {
            this.cartIsLoading(false);
            return;
        }

        this.params.methods().applyPromoCode(promoCodes)
            .then((result: any) => this.ApplyGcOrPromoSuccessCallback(result), (err: any) => this.ApplyGcOrPromoErrorCallback(err))
            .then(() => this.shouldShowPromoMessage(true));
    };

    public removeTicketItem(eventTicket: any) {
        if (!cartInstance.allowModification()) return;
        cartInstance.cartIsLoading(true);
        const request = cartInstance.GetRemoveTicketBookingRequest(eventTicket);

        cartInstance.lastEventId(eventTicket.eventId);
        cartInstance.redirectToGcSummary(false);

        cartInstance.params.methods().removeTicketItem(request)
            .then((sData: any) => {
                cartInstance.ReloadShoppingCart(sData);
                cartInstance.params.methods().onBookingTicketRemove(sData);
            });
    }

    public removeDonationItem(eventTicket: any) {
        if (!cartInstance.allowModification()) return;
        cartInstance.cartIsLoading(true);
        const request = cartInstance.GetRemoveDonationItemRequest(eventTicket.donation);
        cartInstance.params.methods().removeDonationItem(request)
            .then((sData: any) => cartInstance.ReloadShoppingCart(sData));
    };

    public removeGCBookingItem(gcItem: any) {
        if (!cartInstance.allowModification()) return;
        cartInstance.cartIsLoading(true);

        cartInstance.lastEventId(0);
        cartInstance.redirectToGcSummary(true);

        const request = cartInstance.GetRemoveGCBookingItemRequest(gcItem);
        cartInstance.params.methods().removeGCBookingItem(request)
            .then((sData: any) => {
                cartInstance.ReloadShoppingCart(sData);
            });
    };

    public onBoxOfficeControlFocus() {
        var boFee = parseFloat(this.boxOfficeFee().replace(this.currency(), ''));
        this.boxOfficeFee($numberHelper.ToCurrency(boFee));
    };

    public onBoxOfficeControlBlur() {
        if (!this.allowModification()) return;
        this.boxOfficeHasError(false);
        var boFee = parseFloat(this.boxOfficeFee());
        if (isNaN(boFee)) {
            boFee = 0;
        }
        this.cartIsLoading(true);
        const request = {
            EventId: this.boxOfficeFeeEventId(),
            Amount: boFee.toString()
        }
        if (this.boxOfficeFeeOverridable()) {
            this.params.methods().applyBoxOfficeFee(request).then((sData: any) => this.ReloadShoppingCart(sData), () => this.OnBoxOfficeFeeApplicationError());
        } else {
            this.cartIsLoading(false);
        }

        this.boxOfficeFee(this.currency() + $numberHelper.ToCurrency(boFee));
    };

    public updateCartDetailLabel() {
        if ($("#cart-items-content").hasClass("show")) {
            this.cartDetailLabel("Show detail");
        } else {
            this.cartDetailLabel("Hide detail");
        }
    }

    public onCompleteDataClick(ticket: any) {
        if (cartInstance.params.methods && cartInstance.params.methods().completeDataEntry) {
            cartInstance.params.methods().completeDataEntry({ eventId: ticket.eventId, sessionTimeId: ticket.sessionTimeId, sectionId: ticket.sectionId });
        }
    }

    public navigateAndScroll(link: any) {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;

        if ('parentIFrame' in window) {
            (window as any).parentIFrame.sendMessage('TBWidgetScrollToTopInvoke');
        }

        window.location.href = link;
    }

    private OnBoxOfficeFeeApplicationError() {
        this.cartIsLoading(false);
        this.boxOfficeHasError(true);
    }

    private ApplyGcOrPromoSuccessCallback(data: any) {
        if (data.promotionErrorMessage && data.promotionErrorMessage.length > 0) {
            this.hasPromoCodeError(true);
            $.each(data.promotionErrorMessage, (index) => {
                this.promoErrorMessages.push({ message: data.promotionErrorMessage[index] });
            });
        }
        

        if (!this.hasPromoCodeError()) {
            this.promoErrorMessages([]);
            this.promoCode('');
            this.showAppliedPromoButtonLabel(true);
            setTimeout(() => {
                this.showAppliedPromoButtonLabel(false);
            }, 2000);
        }
        return this.ReloadShoppingCart(data);
    }

    private GetNewPromoErrorMessage(message: string) {
        if (message.length <= 0) {
            return '';
        }
        if (/has been refunded/.test(message)) {
            var refundedMessage = message.replace('The Gift Certificate ', '');
            refundedMessage = refundedMessage.substring(0, refundedMessage.indexOf('has been refunded') - 2);
            return 'The following code/s have been refunded: ' + refundedMessage;
        }
        if (/outside the validity period/.test(message)) {
            return message.replace('The following code/s are already outside the validity period:', 'The following code/s have expired:');
        }
        if (/valid but are not applied/.test(message)) {
            return message.replace('The following are valid but are not applied:', 'The following code/s are valid but have not been applied:');
        }
        if (/has 0 remaining balance/.test(message)) {
            var balanceMessage = message.replace('Gift Certificate ', '');
            balanceMessage = balanceMessage.substring(0, balanceMessage.indexOf('you have entered has 0 remaining balance') - 2);
            return 'The following code/s have no balance remaining: ' + balanceMessage;
        }
        return message;
    }

    private ApplyGcOrPromoErrorCallback(err: any) {
        console.error(err);
    }

    //BEGIN MAPPERS
    private MapTicketData(ticket: TicketModel, seats: any) {
        const gcAndPromoApplied: any[] = [];

        $.each(ticket.appliedGiftCertificates, (index: number, value: any) => {
            gcAndPromoApplied.push(value.code);
        });

        $.each(ticket.bookingDiscounts, (index: number, value: any) => {
            gcAndPromoApplied.push(value.code);
        });

        let ticketLabel = '';

        let ticketNamePrefix = '';

        const seatNames: any[] = [];
        $.each(seats, (index: number, value: any) => {
            if (value.sectionId === ticket.sectionId && value.eventDateId === ticket.eventDate.id && ticket.ticketType.id === value.ticketPriceId) {
                seatNames.push(value.rowName + value.seatNumber);
            }
        });
        
        if (seatNames.length > 0) {
            ticketNamePrefix = ' — Seats (' + seatNames.join(', ') + ')';
        }

        if (ticket.eventDate.isUsingAlternateLabel) {
            ticketLabel = ticket.eventDate.alternateLabel;
        } else {
            ticketLabel = moment(ticket.eventDate.eventStartDate).format(this.uiStrings.dateFormat);
        }

        ticketLabel += ' ' + ticket.section.name + ticketNamePrefix;
        return {
            accountId: ticket.accountId,
            ticketTypeName: ticket.ticketType.name,
            ticketName: ticketLabel,
            ticketPrice: $numberHelper.ToCurrency(ticket.totalPricePerTicketName),
            bookingFee: $numberHelper.ToCurrency(ticket.ticketFee),
            processingFee: $numberHelper.ToCurrency(ticket.processingFee),
            gcAndPromoApplied: gcAndPromoApplied.join(', '),
            totalDeductions: $numberHelper.ToCurrency(ticket.totalDeductions),
            subtotal: $numberHelper.ToCurrency(ticket.totalPricePerTicketName + ticket.processingFee + ticket.ticketFee - ticket.totalDeductions),
            quantity: ticket.quantity,
            isFree: ticket.event.isFree,
            isCompleted: ticket.isCompleted,
            isUsingAlternateLabel: ticket.eventDate.isUsingAlternateLabel,
            eventId: ticket.event.id,
            sectionId: ticket.section.id,
            sessionTimeId: ticket.eventDate.id,
            ticketTypeId: ticket.ticketType.id,
            dataEntryPath: this.urlService.GetDataEntryPageUrl(ticket.event.id, ticket.eventDate.id, ticket.section.id),
            timezoneDisplay: ticket.eventDate.timezoneDisplay,
            ticketTypeQuantity: ticket.ticketType.quantity,
            pricingGroupId: ticket.ticketType.pricingGroupId
        };
    }

    private MapDonationData(donation: any) {
        const _appliedGcs: any[] = [];
        //to do: use UI prop
        $.each(donation.appliedGiftCertificates, (index: number, value: any) => {
            _appliedGcs.push(value.code);
        });
        var _feeInfo = '';
        if (donation.processingFee > 0) {
            _feeInfo = '+' + this.currency() + $numberHelper.ToCurrency(donation.processingFee) + ' processing fee';
        }

        return {
            actualAmount: donation.donatedAmount,
            subtotal: $numberHelper.ToCurrency(donation.donatedAmount + donation.processingFee),
            eventId: donation.eventId,
            sessionTimeId: donation.sessionTimeId,
            value: $numberHelper.ToCurrency(donation.donatedAmount),
            feeInfo: _feeInfo,
            appliedGcAmount: $numberHelper.ToCurrency(donation.appliedGCAmount),
            appliedGcs: _appliedGcs.join(', ')
        };
    }

    private MapGiftCertificateBooking(gcBooking: any) {
        return {
            accountId: gcBooking.accountId,
            bookingDiscounts: gcBooking.bookingDiscounts,
            name: gcBooking.giftCertificateTypeName,
            processingFee: gcBooking.processingFee,
            bookingFee: gcBooking.bookingFee,
            quantity: gcBooking.quantity,
            surcharge: gcBooking.surcharge,
            totalValuePurchased: gcBooking.totalValuePurchased,
            total: gcBooking.totalValuePurchased,
            typeId: gcBooking.giftCertificateTypeId,
            discountAmount: gcBooking.discountAmount,
            from: gcBooking.from,
            to: gcBooking.to,
            value: gcBooking.value
        };
    }

    private MapGiftCertificateBookingList(gcBookings: any) {
        const gcs: any[] = [];

        $.each(gcBookings, (index: number, value: any) => {
            var gcBookingVm = this.MapGiftCertificateBooking(value) as any;
            var i = gcs.findIndex((g: any) => { return g.typeId === gcBookingVm.typeId });

            var subtotal = 0;
            if (i >= 0) {
                gcs[i].totalBookingFee += gcBookingVm.bookingFee;
                gcs[i].totalProcessingFee += gcBookingVm.processingFee;
                gcs[i].totalDiscountAmount += gcBookingVm.discountAmount;
                gcs[i].totalValuePurchased += gcBookingVm.totalValuePurchased;
                gcs[i].totalValue += gcBookingVm.value;
                gcs[i].quantity += gcBookingVm.quantity;

                gcs[i].totalBookingFeeDisplay = $numberHelper.ToCurrency(gcs[i].totalBookingFee);
                gcs[i].processingFeeDisplay = $numberHelper.ToCurrency(gcs[i].totalProcessingFee);
                gcs[i].totalDiscountAmountDisplay = $numberHelper.ToCurrency(gcs[i].totalDiscountAmount);
                gcs[i].totalValuePurchasedDisplay = $numberHelper.ToCurrency(gcs[i].totalValuePurchased);
                gcs[i].totalValueDisplay = $numberHelper.ToCurrency(gcs[i].totalValue);

                subtotal = gcs[i].totalValue + gcs[i].totalProcessingFee + gcs[i].totalBookingFee - gcs[i].totalDiscountAmount;
                gcs[i].subtotal = $numberHelper.ToCurrency(subtotal);
            } else {
                gcBookingVm.totalBookingFee = gcBookingVm.bookingFee;
                gcBookingVm.totalProcessingFee = gcBookingVm.processingFee;
                gcBookingVm.totalDiscountAmount = gcBookingVm.discountAmount;
                gcBookingVm.totalValue = gcBookingVm.value;
                gcBookingVm.totalBookingFeeDisplay = $numberHelper.ToCurrency(gcBookingVm.totalBookingFee);
                gcBookingVm.processingFeeDisplay = $numberHelper.ToCurrency(gcBookingVm.totalProcessingFee);
                gcBookingVm.totalDiscountAmountDisplay = $numberHelper.ToCurrency(gcBookingVm.totalDiscountAmount);
                gcBookingVm.totalValuePurchasedDisplay = $numberHelper.ToCurrency(gcBookingVm.totalValuePurchased);
                gcBookingVm.totalValueDisplay = $numberHelper.ToCurrency(gcBookingVm.totalValue);
                subtotal = gcBookingVm.totalValue + gcBookingVm.processingFee + gcBookingVm.totalBookingFee - gcBookingVm.totalDiscountAmount;
                gcBookingVm.subtotal = $numberHelper.ToCurrency(subtotal);

                gcs.push(gcBookingVm);
            }
        });

        $.each(gcs, (index: number, value: any) => {
            value.promoCodes = [];

            $.each(value.bookingDiscounts, (i: number, v: any) => {
                value.promoCodes.push(v.code);
            });
        });

        return gcs;
    }

    private MapGcOrPromoData(gcOrPromoData: any) {
        return {
            amount: $numberHelper.ToCurrency(gcOrPromoData.Amount),
            feeAmount: $numberHelper.ToCurrency(gcOrPromoData.FeeAmount),
            code: gcOrPromoData.Code
        };
    }

    private MapGcOrPromoList(appliedGCs: any) {
        const gcs: any[] = [];

        $.each(appliedGCs, (index: number, value: any) => {
            gcs.push(this.MapGcOrPromoData(value));
        });

        return gcs;
    }

    public MapPromoCodesApplied(promoCodeApplied: any) {
        let label = '';
        if (!promoCodeApplied.isPromoGC) {
            label = 'Applied promo code';
        } else if (promoCodeApplied.isPromoGC) {
            label = 'Applied gift certificate';
        }
        const pCodeApplied = {
            label: label,
            code: promoCodeApplied.code,
            amountUsed: $numberHelper.ToCurrency(promoCodeApplied.discountAmount),
            remainingBalance: $numberHelper.ToCurrency(promoCodeApplied.remainingBalance),
        };

        return pCodeApplied;
    }

    // END MAPPERS

    public GetRemoveTicketBookingRequest(ticketViewModel: any) {
        return [{
            AccountId: ticketViewModel.accountId,
            EventId: ticketViewModel.eventId,
            Quantity: ticketViewModel.quantity,
            SectionId: ticketViewModel.sectionId,
            SessionTimeId: ticketViewModel.sessionTimeId,
            TicketTypeId: ticketViewModel.ticketTypeId
        }];
    }

    public GetRemoveDonationItemRequest(donationItem: any) {
        return [{
            Amount: donationItem.actualAmount,
            EventId: donationItem.eventId,
            SessionTimeId: donationItem.sessionTimeId
        }];
    }

    public GetRemoveGCBookingItemRequest(gcBooking: any) {
        return [{
            AccountId: gcBooking.accountId,
            BookingDiscounts: gcBooking.bookingDiscounts,
            BookingFee: gcBooking.bookingFee,
            DiscountAmount: gcBooking.discountAmount,
            From: gcBooking.from,
            GiftCertificateTypeId: gcBooking.typeId,
            GiftCertificateTypeName: gcBooking.name,
            ProcessingFee: gcBooking.processingFee,
            Quantity: gcBooking.quantity,
            To: gcBooking.to,
            Total: gcBooking.total,
            TotalBookingFee: gcBooking.totalBookingFee,
            TotalDiscountAmount: gcBooking.totalDiscountAmount,
            TotalValue: gcBooking.totalValue,
            TotalValuePurchased: gcBooking.totalValuePurchased,
            value: gcBooking.value
        }];
    }
}

export default class ShoppingCart {
    constructor() {
        ko.components.register('shopping-cart', {
            viewModel: (params: any) => new ShoppingCartViewModel(params),
            template: `
            <div id="my-cart" class="tryb-card tryb-cart position-relative" style="top: 0;" data-bind="css: { 'border-bottom-none': isFrame, 'cart-shadow': !isFrame() }" role="article">
                <div class="d-none tryb-card-header justify-content-between tryb-wgt-header tryb-wgt-header-txt" data-bind="css: { 'd-flex': !isFrame()}">
                    <div data-bind="visible: allowModification">
                        <i class="zmdi zmdi-shopping-cart"></i>
                        <span>Your cart</span>
                    </div>
                    <div data-bind="visible: !allowModification()">
                        <span>Order summary</span>
                    </div>
                    <div class="d-block d-lg-none">
                        <a href="#" data-toggle="collapse" class="text-white btn-link pr-0 text-underlined" data-target="#cart-items-content" data-bind="click: updateCartDetailLabel, css: { 'collapsed': !lgDevice() }">
                            <span data-bind="text: cartDetailLabel"></span>
                        </a>
                        <a href="#" data-toggle="collapse" class="btn-link pr-0 pl-1 text-white" data-target="#cart-items-content" data-bind="click: updateCartDetailLabel, css: { 'collapsed': !lgDevice() }">
                            <i class="zmdi zmdi-chevron-up zmdi-hc-2x"></i>
                        </a>
                    </div>
                </div>
                <div class="tryb-card-content">
                    <div class="tryb-cart-content" data-bind="css: { 'border-bottom' : !isFrame()}">
                        <div id="cart-items-content" class="border-bottom collapse" data-bind="css: {'show': lgDevice() || isFrame()}">
                            <div data-bind="foreach: bookingTickets">
                                <div class="cart-item pr-3 pl-3 pt-3">
                                    <div class="d-flex justify-content-between align-items-center cart-title mb-2" data-bind="css: {'collapse-trigger': !$parents[0].isFrame() },attr: {'data-target': '#cart-collapsible-item-' + $index(), 'data-toggle': !$parents[0].isFrame() ? 'collapse': 'none'}">
                                        <h5 class="mb-0">
                                            <a href="#" data-toggle="collapse" data-bind="visible: !$parents[0].isFrame(), text: eventName, attr: {'data-target': '#cart-collapsible-item-' + $index()}"></a>
                                            <span data-bind="visible: $parents[0].isFrame(), text: eventName"></span>
                                        </h5>
                                        <a href="#" data-toggle="collapse" data-bind="attr: {'data-target': '#cart-collapsible-item-' + $index(), 'class': $parents[0].lgDevice() ? 'btn-link pr-0 d-none d-lg-block' : 'btn-link pr-0 d-none d-lg-block', 'aria-label': ('Collapse/Expand ' + eventName)}">
                                            <i class="zmdi zmdi-chevron-up zmdi-hc-2x"></i>
                                        </a>
                                    </div>
                                    <div data-bind="attr: {'id': 'cart-collapsible-item-' + $index(), 'class': $parents[0].lgDevice() ? 'collapse show' : 'collapse-show'}">
                                        <!-- EVENT BOOKING TICKETS -->
                                        <div data-bind="foreach: tickets">
                                            <div class="ticket-item">
                                                <div>
                                                    Ticket: <span class="ts-span" data-bind="text: ticketTypeName"></span>
                                                </div>
                                                <div>
                                                    Qty: <span data-bind="text: quantity"></span>
                                                </div>
                                                <div>
                                                    When:
                                                    <span data-bind="text: ticketName, visible: !isUsingAlternateLabel, attr: { title: timezoneDisplay }"></span>
                                                    <span data-bind="text: ticketName, visible: isUsingAlternateLabel"></span>
                                                </div>
                                                <div data-bind="visible: !isFree">
                                                    <span>Price: </span><span data-bind="html: $parents[1].currency"></span><span data-bind="text: ticketPrice"></span>
                                                    <span data-bind="visible: bookingFee > 0 || (bookingFee > 0 && processingFee > 0)">(<span data-bind="visible: bookingFee > 0">+<span data-bind="html: $parents[1].currency"></span><span data-bind="text: bookingFee"></span><span> ticket fee</span></span><span data-bind="visible: bookingFee > 0 && processingFee > 0"><span> </span><span>+ <span data-bind="html: $parents[1].currency"></span></span><span data-bind="text: processingFee"></span><span> processing fee</span></span>)</span>
                                                    <span data-bind="visible: processingFee > 0 && bookingFee <= 0">(+<span data-bind="html: $parents[1].currency"></span><span data-bind="text: processingFee"></span><span> processing fee</span>)</span>
                                                </div>
                                                <div data-bind="visible: gcAndPromoApplied.length > 0">
                                                    <span>Discount: </span><span data-bind="html: $parents[1].currency"></span><span data-bind="text: totalDeductions"></span> (<span data-bind="text: gcAndPromoApplied"></span>)
                                                </div>
                                                <div class="d-flex justify-content-between mt-0 align-items-center">
                                                    <div class="mb-2">
                                                        <strong data-bind="visible: !isFree">
                                                            Subtotal:
                                                            <span data-bind="html: $parents[1].currency"></span><span data-bind="text: subtotal"></span>
                                                        </strong>
                                                        <strong data-bind="visible: isFree">
                                                            Free
                                                        </strong>
                                                    </div>

                                                    <a href="#" class="btn-link danger pr-0 pt-0" data-bind="click: $parents[1].removeTicketItem, visible: $parents[1].allowModification, attr: {'aria-label' : ('Remove ticket from cart ' +  quantity + ' ' + ticketTypeName + ' ' + (isFree ? 'Free' : $parents[1].currency() + subtotal))}">
                                                        <i class="zmdi zmdi-close"></i>
                                                        <span>
                                                            Remove
                                                        </span>
                                                    </a>
                                                </div>
                                                <div data-bind="if: isCompleted === false, visible: $parents[1].allowModification">
                                                    <div class="mb-2 text-danger" data-bind="visible: !$parents[1].isFrame()">
                                                        Please <a href="#" data-bind="attr: {href: dataEntryPath}" class="text-underlined text-danger"><strong>complete data</strong></a> or remove
                                                    </div>
                                                    <div class="mb-2 text-danger" data-bind="visible: $parents[1].isFrame">
                                                        Please <a href="#" data-bind="click: $parents[1].onCompleteDataClick" class="text-underlined text-danger"><strong>complete data</strong></a> or remove
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- DONATION CART ITEM -->
                                        <div data-bind="if: donation">
                                            <div class="border-top pt-3">
                                                <div>Donation</div>
                                                <div>
                                                    Value <span data-bind="html: $parents[0].currency"></span><span data-bind="text: donation.value"></span>
                                                    <span data-bind="visible: donation.feeInfo != null && donation.feeInfo.length > 0">(<span data-bind="text: donation.feeInfo"></span>)</span>
                                                </div>
                                                <div data-bind="if: donation.appliedGcAmount > 0">
                                                    Gift certificate: <span data-bind="html: $parents[0].currency"></span><span data-bind="text: donation.appliedGcAmount"></span>
                                                    (<span data-bind="text: donation.appliedGcs"></span>)
                                                </div>
                                                <div class="d-flex justify-content-between mt-0 align-items-center">
                                                    <div class="mb-2">
                                                        <strong>
                                                            Subtotal:
                                                            <span data-bind="html: $parents[0].currency"></span><span data-bind="text: donation.subtotal, attr: {id: 'donation-amount-' + donation.eventId}"></span>
                                                        </strong>
                                                    </div>
                                                    <a href="#" class="btn-link danger pr-0 pt-0" data-bind="click: $parent.removeDonationItem, visible: $parent.allowModification, attr: {'aria-label' : ('Remove donation ' + donation.subtotal + $parents[0].currency())}">
                                                        <i class="zmdi zmdi-close"></i>
                                                        <span>
                                                            Remove
                                                        </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- GIFT CERT BOOKINGS -->
                            <div data-bind="if: bookingGCs().length > 0">
                                <div class="border-bottom">
                                    <div class="cart-item pr-3 pl-3 pt-3">
                                        <div class="d-flex justify-content-between align-items-center cart-title mb-2" data-target="#gc-booking" data-bind="css: {'collapse-trigger': !isFrame()},attr: {'data-toggle': !isFrame() ? 'collapse' : 'none' }">
                                            <h5 class="mb-0">Gift Certificates</h5>
                                            <a href="#" data-toggle="collapse" data-target="#gc-booking" data-bind="visible: !isFrame(), attr: {'class': lgDevice() ? 'btn-link pr-0 d-none d-lg-block' : 'btn-link pr-0 d-none d-lg-block'}">
                                                <i class="zmdi zmdi-chevron-up zmdi-hc-2x"></i>
                                            </a>
                                        </div>
                                        <div id="gc-booking" class="collapse show" data-bind="attr: {'class': lgDevice() ? 'collapse show' : 'collapse-show'}">
                                            <div data-bind="foreach: bookingGCs">
                                                <div class="ticket-item">
                                                    <div>
                                                        GC: <span data-bind="text: name"></span>
                                                    </div>
                                                    <div>
                                                        Qty: <span data-bind="text: quantity"></span>
                                                    </div>
                                                    <div>
                                                        <span data-bind="html: $parent.currency"></span><span data-bind="text: totalValueDisplay"></span>
                                                        <span data-bind="visible: totalBookingFeeDisplay > 0 || (totalBookingFeeDisplay > 0 && processingFee > 0)">(<span data-bind="visible: totalBookingFeeDisplay > 0">+<span data-bind="html: $parent.currency"></span><span data-bind="text: totalBookingFeeDisplay"></span><span> booking fee</span></span><span data-bind="visible: totalBookingFeeDisplay > 0 && processingFee > 0"><span>, </span><span>+<span data-bind="html: $parent.currency"></span></span><span data-bind="text: processingFeeDisplay"></span><span> processing fee</span></span>)</span>
                                                        <span data-bind="visible: totalBookingFeeDisplay <= 0 && processingFee > 0">(<span>+<span data-bind="html: $parent.currency"></span></span><span data-bind="text: processingFeeDisplay"></span><span> processing fee</span>)</span>
                                                    </div>
                                                    <div data-bind="if: promoCodes.length > 0">
                                                        Discount: <span data-bind="html: $parent.currency"></span><span data-bind="text: totalDiscountAmountDisplay"></span>
                                                        (<span data-bind="text: promoCodes.join(', ')"></span>)
                                                    </div>
                                                    <div class="d-flex justify-content-between mt-0 align-items-center">
                                                        <div class="mb-2">
                                                            <strong>
                                                                Subtotal:
                                                                <span data-bind="html: $parent.currency"></span><span data-bind="text: subtotal"></span>
                                                            </strong>
                                                        </div>

                                                        <a href="#" class="btn-link danger pr-0 pt-0" data-bind="click: $parent.removeGCBookingItem, visible: $parent.allowModification, attr: {'aria-label' : ('Remove ' + quantity + ' Gift Certificate ' + name + ' ' + subtotal + $parent.currency())}" aria-live="off">
                                                            <i class="zmdi zmdi-close"></i>
                                                            <span>
                                                                Remove
                                                            </span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- GC / PROMO APPLICATION -->
                        <div class="border-bottom p-3" data-bind="visible: shouldShowGcOrPromoApplication">
                            <div data-bind="visible: allowModification">
                                <label class="form-field-label text-secondary tryb-wgt-txt" id="gcHeader">Gift certificate / Promotion code</label>
                                <div class="position-relative input-btn-container">
                                    <input id="txt-apply-promo" type="text" class="form-control" data-bind="value: promoCode, valueUpdate: 'input', attr: {class: hasPromoCodeError() ? 'form-control is-invalid' : 'form-control'}, event: {keyup: resetPromoError}" aria-labelledby="gcHeader" aria-live="off"/>
                                    <button id="btn-apply-promo" class="btn position-absolute tryb-button tryb-button-sm outlined primary" data-bind="click: applyPromoCode, enable: gcApplyEnabled" aria-label="Apply Gift Certificate or Promotional Code">
                                        <span data-bind="visible: showAppliedPromoButtonLabel">Applied</span>
                                        <span data-bind="visible: !showAppliedPromoButtonLabel()">Apply</span>
                                    </button>
                                </div>
                                <div class="invalid-feedback d-block mb-0" data-bind="if: hasPromoCodeError">
                                    <div data-bind="foreach: promoErrorMessages">
                                        <div>
                                            <strong style="font-size: 0.8rem;" data-bind="text: message"></strong>
                                        </div>
                                    </div>
                                </div>
                                <div data-bind="if: shouldShowPromoMessage">
                                    <strong style="font-size: 0.8rem;" data-bind="text: promoMessage"></strong>
                                </div>
                            </div>
                            <div id="promo-code-applied" data-bind="foreach: promoCodesApplied">
                                <div class="promo-item pb-2">
                                    <div class="d-flex justify-content-between">
                                        <div data-bind="text: label">
                                        </div>
                                        <div data-bind="text: code"></div>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            Amount used
                                        </div>
                                        <div>
                                            <span data-bind="html: $parents[1].currency"></span><span data-bind="text: amountUsed"></span>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            Remaining Balance
                                        </div>
                                        <div>
                                            (<span data-bind="html: $parents[1].currency"></span><span data-bind="text: remainingBalance"></span>)
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- SUBTOTAL -->
                        <div class="border-bottom p-3 cart-subtotal" data-bind="visible: shouldShowSubtotal">
                            <div class="d-flex justify-content-between">
                                <div>
                                    Tickets <span data-bind="text: 'x ' + cartTicketCount()"></span>
                                </div>
                                <div>
                                    <span data-bind="html: currency"></span><span id="subtotal-ticket-amount" data-bind="text: totalTicketAmount"></span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between" data-bind=" totalTryBookingFee() > 0">
                                <div>
                                    Ticket Fee
                                </div>
                                <div>
                                    <span data-bind="html: currency"></span><span id="subtotal-booking-fee" data-bind="text: totalTryBookingFee"></span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between" data-bind="if: totalTicketProcessingFee() > 0">
                                <div>
                                    <span>Processing Fee</span>
                                </div>
                                <div>
                                    <span data-bind="html: currency"></span><span id="subtotal-procfee" data-bind="text: totalTicketProcessingFee"></span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center" data-bind="if: hasBoxOfficeFee">
                                <div>
                                     <span>Quicksale Fee</span>
                                </div>
                                <div>
                                    <input style="max-width: 100px;" id="subtotal-bof" type="text" data-bind="numeric, value: boxOfficeFee, visible: allowModification() && boxOfficeFeeOverridable(), event: { focus: onBoxOfficeControlFocus, blur: onBoxOfficeControlBlur }, attr: { class: boxOfficeHasError() ? 'form-control form-control-sm text-right is-invalid' : 'form-control form-control-sm text-right' }" />
                                     <span data-bind="visible: !allowModification() || !boxOfficeFeeOverridable(), html: boxOfficeFee"></span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between" data-bind="if: totalGcAmount() > 0">
                                <div>
                                    Gift Certificates <span data-bind="text: 'x ' + cartGcCount()"></span>
                                </div>
                                <div>
                                    <span data-bind="html: currency"></span><span id="subtotal-gc" data-bind="text: totalGcAmount"></span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between" data-bind="if: miscellaneous() > 0">
                                <div>
                                    Donation
                                </div>
                                <div>
                                    <span data-bind="html: currency"></span><span id="subtotal-misc" data-bind="text: miscellaneous"></span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between" data-bind="if: promotionCodes().length > 0">
                                <div>
                                    Discounts
                                </div>
                                <div>
                                    (<span data-bind="html: currency"></span><span id="subtotal-dc" data-bind="text: discounts"></span>)
                                </div>
                            </div>
                            <div class="d-flex justify-content-between" data-bind="if: surchargeAmount() > 0">
                                <div data-bind="text: surchargeLabel">
                                </div>
                                <div>
                                    <span data-bind="html: currency"></span><span id="subtotal-surcharge-amount" data-bind="text: surchargeAmount"></span>
                                </div>
                            </div>
                        </div>

                        <!-- BUY MORE LINKS -->
                        <div class="p-3" data-bind="visible: shouldShowBuyMoreLinks">
                            <div class="d-flex flex-wrap">
                                <div class="mb-1" data-bind="css: {'w-50 d-flex align-items-center': showBuyMoreTickets(), 'd-none': !showBuyMoreTickets()}">
                                    <a id="buy-more-link" href="#" class="btn-link pl-0 pt-0 pb-0 text-left" data-bind="click: navigateAndScroll.bind($data, links().buyMoreLink)">
                                        <i class="zmdi zmdi-chevron-right font-weight-bolder"></i>
                                        <span class="text-underlined">
                                            Buy more tickets
                                        </span>
                                    </a>
                                </div>

                                <div class="mb-1" data-bind="css: {'w-50 d-flex align-items-center': showFindOtherEvents(), 'd-none': !showFindOtherEvents()}">
                                    <a id="find-other-events-link" href="#" class="btn-link pt-0 pb-0 text-left" data-bind="click: navigateAndScroll.bind($data, links().findOtherEventsLink)">
                                        <i class="zmdi zmdi-chevron-right font-weight-bolder"></i>
                                        <span class="text-underlined">
                                            Find other events
                                        </span>
                                    </a>
                                </div>
                                <div class="mb-1" data-bind="css: {'w-50 d-flex align-items-center': showBuyGc(), 'd-none': !showBuyGc()}">
                                    <a id="buy-gc-link" href="#" class="btn-link pl-0 pt-0 pb-0 text-left" data-bind="click: navigateAndScroll.bind($data, links().buyGiftCertificateLink)">
                                        <i class="zmdi zmdi-chevron-right font-weight-bolder"></i>
                                        <span class="text-underlined">
                                            Buy gift certificates
                                        </span>
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- TOTAL AMOUNT -->
                    <div class="d-none justify-content-end align-items-center p-3" data-bind="css: { 'd-flex': !isFrame()}">
                        <!-- <a href="#" class="btn tryb-button primary">Checkout</a> -->
                        <h5 class="mb-0 text-right" tabindex="0" data-bind="attr: {'aria-label': ('Total' + totalAmount() + currency())}">
                            <span class="text-black mr-2">TOTAL:</span>
                            <span data-bind="html: currency"></span>
                            <span id="cart-total-amount" data-bind="text: totalAmount"></span>
                        </h5>
                        <input id="cart-total-amount-value" type="hidden" data-bind="value: totalAmount" />
                    </div>
                </div>

                <!-- Cart Spinner / Loader -->
                <div data-bind="if: cartIsLoading">
                    <div class="position-absolute d-flex justify-content-center align-items-center"
                        style="top:0;left:0; height:100%; width: 100%; background-color: rgba(255,255,255, 0.5)">
                        <div class="spinner-border"></div>
                    </div>
                </div>
            </div>
            `
        })
    }
}